'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_totp_Migration$Account(secret, name, issuer, algorithm, digits, kind, period) {
  this.jH = null;
  this.nd = null;
  this.nb = null;
  this.oG = 0;
  this.oH = 0;
  this.nc = 0;
  this.lR = 0;
  this.jH = secret;
  this.nd = name;
  this.nb = issuer;
  this.oG = algorithm;
  this.oH = digits;
  this.nc = kind;
  this.lR = period;
}
export { $c_Lpresto_ui_totp_Migration$Account as $c_Lpresto_ui_totp_Migration$Account };
$p = $c_Lpresto_ui_totp_Migration$Account.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_totp_Migration$Account;
/** @constructor */
function $h_Lpresto_ui_totp_Migration$Account() {
}
export { $h_Lpresto_ui_totp_Migration$Account as $h_Lpresto_ui_totp_Migration$Account };
$h_Lpresto_ui_totp_Migration$Account.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Account"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.jH));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.nd));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.nb));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.oG);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.oH);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.nc);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.lR);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 7);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_ui_totp_Migration$Account) && (((((((this.oG === x$0.oG) && (this.oH === x$0.oH)) && (this.nc === x$0.nc)) && (this.lR === x$0.lR)) && (this.jH === x$0.jH)) && (this.nd === x$0.nd)) && (this.nb === x$0.nb))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 7;
});
$p.s = (function() {
  return "Account";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.jH;
      break;
    }
    case 1: {
      return this.nd;
      break;
    }
    case 2: {
      return this.nb;
      break;
    }
    case 3: {
      return this.oG;
      break;
    }
    case 4: {
      return this.oH;
      break;
    }
    case 5: {
      return this.nc;
      break;
    }
    case 6: {
      return this.lR;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Hk = (function() {
  return ((this.nb === "") ? this.nd : ((this.nb + ": ") + this.nd));
});
function $isArrayOf_Lpresto_ui_totp_Migration$Account(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mr)));
}
export { $isArrayOf_Lpresto_ui_totp_Migration$Account as $isArrayOf_Lpresto_ui_totp_Migration$Account };
var $d_Lpresto_ui_totp_Migration$Account = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_totp_Migration$Account, "presto.ui.totp.Migration$Account", ({
  mr: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ui_totp_Migration$Account as $d_Lpresto_ui_totp_Migration$Account };
//# sourceMappingURL=presto.ui.totp.-Migration$-Account.js.map
